//  get browser locale
// const defaultLocale = (navigator.language || navigator.userLanguage)?.split(
//   "-",
// )?.[0];

const defaultLocale = "en";

export { defaultLocale };
